import React, { Component, Fragment } from 'react';
import { Input, Button, Table } from 'reactstrap';
import { Link } from 'react-router-dom';

import buscaFonetica from '../../utils/buscaFonetica';

const DAYS = [...Array(7).keys()];

export default class extends Component {
  constructor (props) {
    super(props);

    this.state = {
      filtros: {
        tarefa: "",
        local: "",
        perfil: "",
        dias: [false, false, false, false, false, false, false]
      },
      toggleUpdate: false,
      ...props.value.result
    };
  }

  handleSave = () => {
    this.props.actions.onSaveQrcodeTask({ value: this.state.tarefas.map(tarefa => tarefa.perfis.map(perfil => perfil.dias)).flat(2).filter(dia => !!dia) });
  };

  handleChangeStatus = chaveTarefa => e => {
    let status = e.target.checked?1:0;

    this.setState(({ tarefas, toggleUpdate }) => {
      this.updateSingle(tarefas, chaveTarefa, "status_qrcode", status);

      return {
        toggleUpdate: !toggleUpdate
      };
    });
  };

  update = (tarefas, { id, nome, perfis, ...otherDia }, key, value, cb = () => {}) => {
    const tarefa = tarefas.find(tarefa => tarefa.id === id);
    tarefa[key] = value;
    tarefa.perfis.forEach(perfil => {
      perfil[key] = value;
      perfil.dias.forEach((dia, i) => {
        if (dia || i === otherDia.dia_semana) {
          if (!dia) {
            dia = otherDia;
            perfil.dias[i] = dia;
          }
          dia.id_tarefa = id;
          dia.nome_tarefa = tarefa.nome;
          dia.id_perfil = perfil.id;
          dia.nome_perfil = perfil.nome;
          dia[key] = value;
          cb(dia);
        }
      });
    });
  };

  updateSingle = (tarefas, { id, nome, perfis, ...otherDia }, key, value, cb = () => {}) => {
    const tarefa = tarefas.find(tarefa => tarefa.id === id);
    const perfil = tarefa.perfis.find(perfil => perfil.id === otherDia.id_perfil);

    let dia = perfil.dias.find((_d, i) => i === otherDia.dia_semana);
    if (!dia) {
      dia = otherDia;
      perfil.dias[otherDia.dia_semana] = dia;
    }
    dia.id_tarefa = id;
    dia.nome_tarefa = tarefa.nome;
    dia.id_perfil = perfil.id;
    dia.nome_perfil = perfil.nome;
    dia[key] = value;

    cb(dia);
  };

  get_dias = chaveTarefa => this.state.tarefas
  .find(tarefa => tarefa.id === chaveTarefa.id_tarefa)
  .perfis
  .find(perfil => perfil.id === chaveTarefa.id_perfil)
  .dias;

  handleLocal = chave => e => {
    let value = e.target.value.toUpperCase();

    this.setState(({ tarefas, locais, toggleUpdate }) => {
      this.update(tarefas, chave, "local_qrcode", value);

      return {
        toggleUpdate: !toggleUpdate
      };
    });
  };

  handleFiltro = v => ({ target: { value } }) => this.setState(({ filtros }) => ({
    filtros: {
      ...filtros,
      [v]: value.replace(/^\s+|\s+(?=\s$|\s)/g, '')
    }
  }));

  handleFiltro2 = v => ({ target: { value } }) => this.setState(({ filtros }) => ({
    filtros: {
      ...filtros,
      [v]: value.replace(/^\s+|\s+(?=\s$|\s)/g, '').toUpperCase()
    }
  }));

  handleFiltroDias = v => ({ target: { checked }}) => this.setState(({ filtros }) => {
    filtros.dias[v] = checked;

    return {
      filtros
    };
  });

  filterTasks = value => tarefas => tarefas.filter(tarefa => !value || -1 < buscaFonetica(tarefa.nome).indexOf(value.trim()));
  filterTasksLocal = value => tarefas => tarefas.filter(tarefa => !value || (tarefa.local_qrcode && -1 < buscaFonetica(tarefa.local_qrcode).indexOf(value.trim())));
  filterPerfis = value => tarefa => tarefa.perfis.filter(perfil => !value || -1 < buscaFonetica(perfil.nome).indexOf(value.trim()));
  filterPerfilPorDia = value => perfis => perfis.filter(perfil => value.every(dia => !dia) || value.every((dia, i) => !dia || (perfil.dias[i] && 1 === perfil.dias[i].status_qrcode)));

  render () {
    let { filtros, tarefas } = this.state;

    let filtrosFoneticos = {
      tarefa: buscaFonetica(filtros.tarefa),
      local: buscaFonetica(filtros.local),
      perfil: buscaFonetica(filtros.perfil)
    };

    let filteredTasks = this.filterTasksLocal(filtrosFoneticos.local)(this.filterTasks(filtrosFoneticos.tarefa)(tarefas));
    let filterPerfil = this.filterPerfis(filtrosFoneticos.perfil);
    let filterPorDia = this.filterPerfilPorDia(filtros.dias);

    return (<Fragment>
      <div className="text-right">
        <Button target="_blank" tag={Link} to="/print/agenda/qrcode"><span className="fas fa-qrcode"></span> Imprimir</Button>{' '}
        <Button color="primary" onClick={this.handleSave}><span className="fas fa-save"></span> Salvar</Button>
      </div>
      <br />
      <Table size="sm">
      <thead>
        <tr>
          <th rowSpan={2} className="d-none d-lg-table-cell">#</th>
          <th rowSpan={2}>Tarefa</th>
          <th rowSpan={2} className="d-none d-sm-table-cell">Local</th>
          <th rowSpan={2} className="d-none d-md-table-cell">Perfil</th>
          <th colSpan={7}>Semana</th>
        </tr>
        <tr className="text-center">
          <th>D</th>
          <th>S</th>
          <th>T</th>
          <th>Q</th>
          <th>Q</th>
          <th>S</th>
          <th>S</th>
        </tr>
        <tr>
          <td className="d-none d-lg-table-cell"><Input bsSize="sm" value={filtros.prioridade} onChange={this.handleFiltro("prioridade")} size="1" /></td>
          <td><Input bsSize="sm" value={filtros.tarefa} onChange={this.handleFiltro("tarefa")} /></td>
          <td className="d-none d-sm-table-cell"><Input bsSize="sm" value={filtros.local} onChange={this.handleFiltro2("local")} /></td>
          <td className="d-none d-md-table-cell"><Input bsSize="sm" value={filtros.perfil} onChange={this.handleFiltro2("perfil")} /></td>
          {DAYS.map(i => (
            <td key={i} className="text-center"><Input checked={filtros.dias[i]} type="checkbox" style={{ position: "static", marginLeft: 0 }} onChange={this.handleFiltroDias(i)} /></td>
          ))}
        </tr>
      </thead>
      {filteredTasks.map(v => (<tbody key={v.id}>{filterPorDia(filterPerfil(v))
        .map((p, j, a) => (<tr key={p.id}>
          {!j && <Fragment>
            <td rowSpan={a.length} className="d-none d-lg-table-cell">{v.prioridade}</td>
            <td rowSpan={a.length}>{v.nome}</td>
            <td rowSpan={a.length} className="d-none d-sm-table-cell"><Input bsSize="sm" value={v.local_qrcode || ""} min={5} max={120} onChange={this.handleLocal(v)} /></td>
          </Fragment>}
          <td className="d-none d-md-table-cell">{p.nome}</td>
          {DAYS.map(i => {
            let day = this.get_dias({ id_tarefa: v.id, id_perfil: p.id })[i];

            return (<td key={i} className="text-center"><Input disabled={!v.local_qrcode} checked={!!day && 1 === day.status_qrcode} onChange={this.handleChangeStatus({
              ...v,
              nome_tarefa: v.nome,
              nome_perfil: p.nome,
              id_tarefa: v.id,
              id_perfil: p.id,
              dia_semana: i,
              status: 0
            })} style={{ position: "static", marginLeft: 0 }} type="checkbox" /></td>);
          })}
        </tr>))}
      </tbody>))}
    </Table></Fragment>);
  }
}


// WEBPACK FOOTER //
// ./src/modules/agenda/ListaTarefasConfirmacaoView.js